import ExitToApp from '@material-ui/icons/ExitToApp'
import ShowChart from '@material-ui/icons/ShowChart'
import LibraryBooks from '@material-ui/icons/LibraryBooks'
import { action, observable } from 'mobx'
import { t } from 'i18next'
import React from 'react'
import { isFolder, isItem, isItemsGroup } from '../../app/nav-bar/nav-bar'
import { getRouteName, MONITORING, VIOLATION_LOG } from '../../routes/app-routes'
import { goTo } from '../../utils/router-utils'
import { DEFAULT_SCREEN_WIDTH } from '../app/app-store'
import { APP_STORE, ROUTING_STORE, USER_STORE } from '../stores'
import { getStore } from '../stores-repository'

export const EXIT = 'exit'

export class NavigationMenuStore {
    @observable
    open = false

    @observable
    selectedItem = null

    @observable
    navBarItems = []

    appStore = getStore(APP_STORE)
    routingStore = getStore(ROUTING_STORE)

    constructor() {
        if (this.appStore && this.appStore.screenWidth !== DEFAULT_SCREEN_WIDTH) {
            this.openIfScreenWideEnough()
        }
    }

    @action
    init = () => {
        this.navBarItems = createNavBarItems()
    }

    @action
    openIfScreenWideEnough = () => {
        if (this.appStore.screenWidth > DEFAULT_SCREEN_WIDTH) {
            this.open = true
        }
    }

    @action
    synchronizeWithRoute = () => {
        const currentRoute = this.routingStore.location.pathname
        const findSelectItem = (route, items) => {
            for (let i = 0; i < items.length; i++) {
                const item = items[i]

                if (isItem(item)) {
                    const { hidden = false, selectable = true } = item

                    if (isFolder(item)) {
                        const foundItem = findSelectItem(route, item.children)
                        if (foundItem) return foundItem
                    } else if (item.route === route
                        && selectable && !hidden) {
                        return item
                    }
                }
                if (isItemsGroup(item)) {
                    const foundItem = findSelectItem(route, item.items)
                    if (foundItem) return foundItem
                }
            }

            return null
        }

        this.selectedItem = findSelectItem(currentRoute, this.navBarItems)
        if (!this.selectedItem) {
            this.selectedItem = this.findFirstAvailableMenuItem(this.navBarItems)
        }
    }

    findFirstAvailableMenuItem = items => {
        for (let i = 0; i < items.length; i++) {
            const item = items[i]

            if (isItem(item)) {
                const { hidden = false, selectable = true } = item

                if (!hidden && selectable && isFolder(item)) {
                    const selectableItem = this.findFirstAvailableMenuItem(item.children)
                    if (selectableItem) return selectableItem
                } else {
                    return item
                }
            }
            if (isItemsGroup(item)) {
                const selectableItem = this.findFirstAvailableMenuItem(item.items)
                if (selectableItem) return selectableItem
            }
        }
        return null
    }

    selectMenuItem = item => {
        if (item.route) {
            goTo(item.route)
        }
    }

    @action
    setOpen = open => {
        this.open = open
    }

}

const createNavBarItems = () => {
    const userStore = getStore(USER_STORE)
    return [
        {
            id: 'mainRoutesGroup',
            items: [
                {
                    id: 'monitoringNavLink',
                    icon: <ShowChart/>,
                    label: getRouteName(MONITORING),
                    route: MONITORING,
                },
                {
                    id: 'violationLogNavLink',
                    icon: <LibraryBooks/>,
                    label: getRouteName(VIOLATION_LOG),
                    route: VIOLATION_LOG
                },
            ]
        },

        {
            id: 'exitNavLink',
            icon: <ExitToApp/>,
            label: t('common.exit'),
            onClick: userStore.resetAuthorization
        },
    ]
}
